import auth from "../../middlewares/auth";

export const customerRoutes = [
    {
        path: '/customers',
        component: () => import(/* webpackChunkName: "customers" */ '../../views/customers/Customer'),
        name: 'customers',
        meta: {
            middleware: [
                auth
            ],
            requiredPermissions: ['cloud-service-manage']
        }
    },
    {
        path: '/customer/:id',
        component: () => import(/* webpackChunkName: "customers" */ '../../views/customers/CustomerForm'),
        name: 'update-customer',
        meta: {
            middleware: [
                auth
            ],
            requiredPermissions: ['cloud-service-manage']
        }
    },
    {
        path: '/create-customer',
        component: () => import(/* webpackChunkName: "customers" */ '../../views/customers/CustomerForm'),
        name: 'create-customer',
        meta: {
            middleware: [
                auth
            ],
            requiredPermissions: ['cloud-service-manage']
        }
    },
    {
        path: '/customer/:id/show',
        component: () => import(/* webpackChunkName: "customers" */ '../../views/customers/ViewCustomer'),
        name: 'view-customer',
        meta: {
            middleware: [
                auth
            ],
            requiredPermissions: ['cloud-service-manage']
        }
    },
    {
        path: '/customer/:id/billing',
        component: () => import(/* webpackChunkName: "customers" */ '../../views/customers/CustomerBillList.vue'),
        name: 'view_customer_billing',
        meta: {
            middleware: [
                auth
            ],
            requiredPermissions: ['cloud-service-manage']
        }
    },
    {
        path: '/customer-billing/:customer_id/:id/:date/details',
        component: () => import(/* webpackChunkName: "customers" */ '../../views/customers/CustomerBilIDetails.vue'),
        name: 'view_customer_billing_details',
        meta: {
            middleware: [
                auth
            ],
            requiredPermissions: ['cloud-service-manage']
        }
    },
]